import { v4 as uuidv4, validate as isUuid } from "uuid"

export const DEVICE_ID_STORAGE_KEY = "springcast-device-id"

/**
 * The listener identity sent on every audio and video beacon. Statistics keys unique listeners
 * and the retention curve on it, so it must survive page loads: a fresh id per mount made every
 * return visit a new listener and split one listen across visits.
 *
 * Browsers partition iframe storage per embedding site, so this is stable per site the player is
 * embedded on, not across sites. When storage is unavailable (blocked third-party storage, private
 * mode) it degrades to a per-mount id, which is the previous behavior.
 */
export function resolveDeviceId(storage = defaultStorage()) {
    try {
        const stored = storage?.getItem(DEVICE_ID_STORAGE_KEY)

        if (stored && isUuid(stored)) {
            return stored
        }

        const deviceId = uuidv4()
        storage?.setItem(DEVICE_ID_STORAGE_KEY, deviceId)

        return deviceId
    } catch {
        return uuidv4()
    }
}

function defaultStorage() {
    try {
        return window.localStorage
    } catch {
        return null
    }
}
